wbApp.filter('invoiceForType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 1:
                return $translate.instant('TXT_LAB_COURSE');
            case 2:
                return $translate.instant('TXT_LAB_ACTION_SINGULAR');
            case 3:
                return $translate.instant('TXT_LAB_KINDERGARTEN');
            case 4:
                return $translate.instant('TXT_LAB_RESERVATION');
            case 5:
                return $translate.instant('TXT_LAB_WALLET_DEPOSIT');
            case 6:
                return $translate.instant('TXT_LAB_CUSTOM');
        }
        return "";
    };
}]);